define([
    "dojo/_base/declare",
    "dojo/aspect",
    "dojo/_base/lang",
    "csi",
    "csi/def",
    "csi/def/Field",
    "./NewStyleController"
], function(declare, aspect, lang, csi, def, Field, NewStyleController) {
    var CANDIDATE_QTY = "CandidateQuantity";
    var IS_STYLE_CANDIDATE = "IsStyleCandidate";

    return declare([NewStyleController], {

    	_insertCandidateFields: function(/*csi.view.Widget*/view) {
            this.styleForm = view;

            aspect.after(view, "_updateFieldVisibility", function() {
                // not sure if there is a mutator method/abstraction
                this.defView.getField(IS_STYLE_CANDIDATE).m_control.disabled = true;
            });

            view.insertField(lang.mixin(new Field(), {
                m_id: CANDIDATE_QTY,
                m_typeControl: def.FIELD_TEXT,
                m_onChange: lang.hitch(this, this._onChangeQuantity),
                m_onValidate: lang.hitch(this, this._onValidateQuantity)
            }), 0, true);

            view.insertField(lang.mixin(new Field(), {
                m_id: IS_STYLE_CANDIDATE,
                m_typeControl: def.FIELD_CHECKBOX
            }), 0, true);

            view.addDefaultValue(CANDIDATE_QTY, 1);
            view.addDefaultValue(IS_STYLE_CANDIDATE, true);
        }
    });
});